import type { ReactNode } from 'react'
import { ShieldCheck } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'

import { useOrgStore } from '@/lib/store'
import { MpButton, MpEmptyWorkspace } from '@/ui/components'

export function RequireOrgAdmin({ children }: { children: ReactNode }) {
  const { orgId } = useParams()
  const activeOrgRole = useOrgStore((state) => state.activeOrgRole)
  const isOrgAdmin = activeOrgRole === 'OWNER' || activeOrgRole === 'ADMIN'
  const dashboardPath = orgId ? `/o/${orgId}/dashboard` : '/'

  if (isOrgAdmin) {
    return <>{children}</>
  }

  return (
    <MpEmptyWorkspace
      icon={ShieldCheck}
      title="Розділ доступний адміністратору"
      description="Ваш поточний доступ дозволяє працювати з товарами, аналізом і моніторингом. Керування магазином, оплатами й командою виконує адміністратор."
      action={
        <MpButton asChild variant="secondary">
          <Link to={dashboardPath}>Повернутися до огляду</Link>
        </MpButton>
      }
    />
  )
}
